import React, {  useEffect, useState, useCallback, useMemo } from 'react';
import { useSelector } from "react-redux"; 
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next"  
import { useNavigate } from 'react-router-dom'; 
import { ENDPOINT } from "constants/variables"; 
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { es } from 'date-fns/locale';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box'; 
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import CircularProgress from '@mui/material/CircularProgress';  
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle'; 
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews"; 
import { successErrorAction,warningErrorAction } from "actions/ErrorActions"; 
import "css/generalSettings.css";
import "css/customDialog.css";
import SendIcon from '@mui/icons-material/Send'; 
import Textarea from '@mui/joy/Textarea';
import TextField from '@mui/material/TextField';
import mitecoIcon from "components/photos/sidebars/miteco1.png"; 
import sedeElectronicaIcon from "components/photos/sidebars/sedeelectronica.png";
import ReportTemplateNTCERT from "pages/NT/esirNTSendCERT/ReportTemplateNTCERT";


import PropTypes from 'prop-types';  

const initialStateFromDISendEmail = {
  id: 0,
  ownformdi_id:0,
  defaultStore_id: 0,
  useraccount_id: 0, 
  defaultformatnumber: 1,
  isFinished: true,
  isScanned: false,
  preiddoc_sheet: "", 
  sufiddoc_sheet:0,
  number_dt: "",
  date_sheet: "",
 
  opt_tras_documnettype_entityFJCode: "",
  opt_tras_documentid: "",
  opt_tras_reason_reasonName: "",
  opt_tras_firstname: "",
  opt_tras_lastname1: "",
  opt_tras_lastname2: "",
  opt_tras_name: "", 
  opt_tras_contactname: "",
  opt_tras_reason_reasonAssociation_associationCode: "",
  opt_tras_reason_reasonAssociation_associationDescription: "",
  opt_tras_operatorTypeCode: "",
  opt_tras_operatorTypeDescription: "",
  opt_tras_country_countryCode: "",
  opt_tras_country_countryName: "",
  opt_tras_community_CACode: "",
  opt_tras_community_CAName: "",
  opt_tras_municipality_municipalityCode: "",
  opt_tras_municipality_municipalityName: "",
  opt_tras_province_provinceCode: "",
  opt_tras_province_provinceName: "",
  opt_tras_postalcode_localityCode: "",
  opt_tras_postalcode_localityName: "",
  opt_tras_roadtype_vialCode: "",
  opt_tras_roadtype_vialDescription: "",
  opt_tras_address: "",
  opt_tras_phone: "",
  opt_tras_mail: "",
  opt_tras_nima_centerCode: "",
  opt_tras_nima_centerDenomination: "",
  opt_tras_centerCNAE: "",
  opt_tras_centerEconomicActivity: "",
  opt_tras_pyGR: "",
  opt_tras_licenseplate: "",

  ori_tras_documnettype_entityFJCode: "",
  ori_tras_documentid: "",
  ori_tras_reason_reasonName: "",
  ori_tras_firstname: "",
  ori_tras_lastname1: "",
  ori_tras_lastname2: "",
  ori_tras_name: "",
  ori_tras_contactname: "", 
  ori_tras_reason_reasonAssociation_associationCode: "",
  ori_tras_reason_reasonAssociation_associationDescription: "",
  ori_tras_operatorTypeCode: "",
  ori_tras_operatorTypeDescription: "",
  ori_tras_country_countryCode: "",
  ori_tras_country_countryName: "",
  ori_tras_community_CACode: "",
  ori_tras_community_CAName: "",
  ori_tras_municipality_municipalityCode: "",
  ori_tras_municipality_municipalityName: "",
  ori_tras_province_provinceCode: "",
  ori_tras_province_provinceName: "",
  ori_tras_postalcode_localityCode: "",
  ori_tras_postalcode_localityName: "",
  ori_tras_roadtype_vialCode: "",
  ori_tras_roadtype_vialDescription: "",
  ori_tras_address: "",
  ori_tras_phone: "",
  ori_tras_mail: "",
  ori_tras_nima_centerCode: "",
  ori_tras_nima_centerDenomination: "",
  ori_tras_centerCNAE: "",
  ori_tras_centerEconomicActivity: "",
  ori_tras_pyGR: "",
  ori_tras_licenseplate: "",
    
  aut_tras_documnettype_entityFJCode: "",
  aut_tras_documentid: "",
  aut_tras_reason_reasonName: "",
  aut_tras_firstname: "",
  aut_tras_lastname1: "",
  aut_tras_lastname2: "",
  aut_tras_name: "",
  aut_tras_contactname: "",
  aut_tras_reason_reasonAssociation_associationCode: "",
  aut_tras_reason_reasonAssociation_associationDescription: "",
  aut_tras_operatorTypeCode: "",
  aut_tras_operatorTypeDescription: "",
  aut_tras_country_countryCode: "",
  aut_tras_country_countryName: "",
  aut_tras_community_CACode: "",
  aut_tras_community_CAName: "",
  aut_tras_municipality_municipalityCode: "",
  aut_tras_municipality_municipalityName: "",
  aut_tras_province_provinceCode: "",
  aut_tras_province_provinceName: "",
  aut_tras_postalcode_localityCode: "",
  aut_tras_postalcode_localityName: "",
  aut_tras_roadtype_vialCode: "",
  aut_tras_roadtype_vialDescription: "",
  aut_tras_address: "",
  aut_tras_phone: "",
  aut_tras_mail: "",
  aut_tras_nima_centerCode: "",
  aut_tras_nima_centerDenomination: "",
  aut_tras_centerCNAE: "",
  aut_tras_centerEconomicActivity: "",
  aut_tras_pyGR: "",
  aut_tras_licenseplate: "",
  
  dest_tras_documnettype_entityFJCode: "",
  dest_tras_documentid: "",
  dest_tras_reason_reasonName: "",
  dest_tras_firstname: "",
  dest_tras_lastname1: "",
  dest_tras_lastname2: "",
  dest_tras_name: "",
  dest_tras_contactname: "",
  dest_tras_reason_reasonAssociation_associationCode: "",
  dest_tras_reason_reasonAssociation_associationDescription: "",
  dest_tras_operatorTypeCode: "",
  dest_tras_operatorTypeDescription: "",
  dest_tras_country_countryCode: "",
  dest_tras_country_countryName: "",
  dest_tras_community_CACode: "",
  dest_tras_community_CAName: "",
  dest_tras_municipality_municipalityCode: "",
  dest_tras_municipality_municipalityName: "",
  dest_tras_province_provinceCode: "",
  dest_tras_province_provinceName: "",
  dest_tras_postalcode_localityCode: "",
  dest_tras_postalcode_localityName: "",
  dest_tras_roadtype_vialCode: "",
  dest_tras_roadtype_vialDescription: "",
  dest_tras_address: "",
  dest_tras_phone: "",
  dest_tras_mail: "",
  dest_tras_nima_centerCode: "",
  dest_tras_nima_centerDenomination: "",
  dest_tras_centerCNAE: "",
  dest_tras_centerEconomicActivity: "",
  dest_tras_pyGR: "",
  dest_tras_licenseplate: "",
 
  aut_dest_documnettype_entityFJCode: "",
  aut_dest_documentid: "",
  aut_dest_reason_reasonName: "",
  aut_dest_firstname: "",
  aut_dest_lastname1: "",
  aut_dest_lastname2: "",
  aut_dest_name: "",
  aut_dest_contactname: "",
  aut_dest_reason_reasonAssociation_associationCode: "",
  aut_dest_reason_reasonAssociation_associationDescription: "",
  aut_dest_operatorTypeCode: "",
  aut_dest_operatorTypeDescription: "",
  aut_dest_country_countryCode: "",
  aut_dest_country_countryName: "",
  aut_dest_community_CACode: "",
  aut_dest_community_CAName: "",
  aut_dest_municipality_municipalityCode: "",
  aut_dest_municipality_municipalityName: "",
  aut_dest_province_provinceCode: "",
  aut_dest_province_provinceName: "",
  aut_dest_postalcode_localityCode: "",
  aut_dest_postalcode_localityName: "",
  aut_dest_roadtype_vialCode: "",
  aut_dest_roadtype_vialDescription: "",
  aut_dest_address: "",
  aut_dest_phone: "",
  aut_dest_mail: "",
  aut_dest_nima_centerCode: "",
  aut_dest_nima_centerDenomination: "",
  aut_dest_centerCNAE: "",
  aut_dest_centerEconomicActivity: "",
  aut_dest_pyGR: "",
  aut_dest_licenseplate: "",
  
  rel_trans_documnettype_entityFJCode: "",
  rel_trans_documentid: "",
  rel_trans_name: "",
  rel_trans_contactname: "",
  rel_trans_reason_reasonName: "",
  rel_trans_firstname: "",
  rel_trans_lastname1: "",
  rel_trans_lastname2: "",
  rel_trans_reason_reasonAssociation_associationCode: "",
  rel_trans_reason_reasonAssociation_associationDescription: "",
  rel_trans_operatorTypeCode: "",
  rel_trans_operatorTypeDescription: "",
  rel_trans_country_countryCode: "",
  rel_trans_country_countryName: "",
  rel_trans_community_CACode: "",
  rel_trans_community_CAName: "",
  rel_trans_municipality_municipalityCode: "",
  rel_trans_municipality_municipalityName: "",
  rel_trans_province_provinceCode: "",
  rel_trans_province_provinceName: "",
  rel_trans_postalcode_localityCode: "",
  rel_trans_postalcode_localityName: "",
  rel_trans_roadtype_vialCode: "",
  rel_trans_roadtype_vialDescription: "",
  rel_trans_address: "",
  rel_trans_phone: "",
  rel_trans_mail: "",
  rel_trans_nima_centerCode: "",
  rel_trans_nima_centerDenomination: "",
  rel_trans_centerCNAE: "",
  rel_trans_centerEconomicActivity: "",
  rel_trans_pyGR: "",
  rel_trans_licenseplate: "",

  resp_prod_documnettype_entityFJCode: "",
  resp_prod_documentid: "",
  resp_prod_reason_reasonName: "",
  resp_prod_firstname: "",
  resp_prod_lastname1: "",
  resp_prod_lastname2: "",
  resp_prod_name: "",
  resp_prod_contactname: "", 
  resp_prod_reason_reasonAssociation_associationCode: "",
  resp_prod_reason_reasonAssociation_associationDescription: "",
  resp_prod_operatorTypeCode: "",
  resp_prod_operatorTypeDescription: "",
  resp_prod_country_countryCode: "",
  resp_prod_country_countryName: "",
  resp_prod_community_CACode: "",
  resp_prod_community_CAName: "",
  resp_prod_municipality_municipalityCode: "",
  resp_prod_municipality_municipalityName: "",
  resp_prod_province_provinceCode: "",
  resp_prod_province_provinceName: "",
  resp_prod_postalcode_localityCode: "",
  resp_prod_postalcode_localityName: "",
  resp_prod_roadtype_vialCode: "",
  resp_prod_roadtype_vialDescription: "",
  resp_prod_address: "",
  resp_prod_phone: "",
  resp_prod_mail: "",
  resp_prod_nima_centerCode: "",
  resp_prod_nima_centerDenomination: "",
  resp_prod_centerCNAE: "",
  resp_prod_centerEconomicActivity: "",
  resp_prod_pyGR: "",
  resp_prod_licenseplate: "",
 
  codeler_code: "",
  codeler_name: "",
  description_code: "",
  description_name: "",
  treatmenttypeorigin_code: "",
  treatmenttypeorigin_name: "",
  treatmenttypedestine_code: "",
  treatmenttypedestine_name: "",
  processtypepeorigin_code: "",
  processtypepeorigin_name: "",
  processtypedestine_code: "",
  processtypedestine_name: "",
  dangerousness_name: "",
  charac_danger: "",
  amount: 0,
  end_date_nt: "",
  isindividual: false,
  ismultiple: true,
  frecuency: "",
  number_nt_refused: "",
  isemergency: false,
  reason_emergency: "",
   
  checked_numberDI_sheet:false,
  checked_date_sheet:true,
  checked_opt_tras_documentid:false,
  checked_opt_tras_tradename:false,
  checked_opt_tras_street:false,
  checked_opt_tras_locality:false,
  checked_opt_tras_nima:false,
  checked_opt_tras_opt:false,
  checked_opt_tras_inscription:false,
  checked_ori_tras_documentid:false,
  checked_ori_tras_tradename:false,
  checked_ori_tras_street:false,
  checked_ori_tras_locality:false,
  checked_ori_tras_nima:false,
  checked_ori_tras_opt:false,
  checked_ori_tras_inscription:false,
  checked_dest_tras_documentid:false,
  checked_dest_tras_tradename:false,
  checked_dest_tras_street:false,
  checked_dest_tras_locality:false,
  checked_dest_tras_nima:false,
  checked_dest_tras_opt:false,
  checked_dest_tras_inscription:false,
  checked_rel_trans_documentid:false,
  checked_rel_trans_tradename:false,
  checked_rel_trans_street:false,
  checked_rel_trans_locality:false,
  checked_rel_trans_nima:false,
  checked_rel_trans_opt:false,

  checked_rel_trans_inscription:false,
  checked_aut_tras_opt:false,
  checked_aut_dest_opt:false,
  checked_resp_prod_opt:false,
  checked_codeLER:false,
  checked_amount:false,
  checked_dateDelivery:false,
  checked_amountDelivery:false,
  hasbeensent:false,
  hasbeensentesir:false,
  hasbeenshared:false, 
  statussentesir:0,
  reasonrefund:""
}; 

const typeStatus=[
  {"id":0,"name":"SIN TRAMITAR"},
  {"id":1,"name":"EN TRÁMITE"},
  {"id":2,"name":"RECHAZADO"},
  {"id":3,"name":"EN BORRADOR"},
  {"id":4,"name":"ACEPTADO"}
];


const initialStateStatusNT = {
  id: 0,
  number_nt: "",
  init_date_nt: "",
  end_date_nt: "",
  statussentesir:0,
  reasonrefund:""
}

const NTSendESIRCERT = ({id, showModalNTSendESIRCERT}) => {
  const {t,i18n} = useTranslation(['listDataForms']);
  const token = useSelector((state) => state.loginUser.token);   
  const defaultStore = useSelector((state) => state.loginUser.defaultStore)
  const useraccount_id = useSelector((state) => state.loginUser.useraccount_id);   
  const dispatch = useDispatch();
  const navigate = useNavigate(); 
  const [dataForm, setDataForm] = useState(initialStateFromDISendEmail);
  const [dataState, setDataState] = useState(initialStateStatusNT);
  const [errorsStatus, setErrorsStatus] = useState({});
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [pdfBlob, setPdfBlob] = useState(null);  
  const [pdfUrl, setPdfUrl] = useState(""); // Estado para actualizar el PDF
  const [checklistState, setChecklistState] = useState(false); // Estado para actualizar el PDF
  const [dialogOpen, setDialogOpen] = useState(false); 
  const [dialogMessage, setDialogMessage] = useState(null); // { status: "OK" | "ERROR", errors: string[] }
  const [foundNumberOfNT, setFoundNumberOfNT ]= useState(false);

  const PdfViewer = useMemo(() => {
    return pdfUrl?
      <iframe
        src={pdfUrl} 
        title="PDF Preview"
        style={{ width: '100%', height: '100%', border: 'none' }}
      /> 
    :pdfBlob ? (
      <iframe
        src={URL.createObjectURL(pdfBlob)}
        title="PDF Preview"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
    ) : null;
  }, [pdfBlob,pdfUrl]);

  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showModalNTSendESIRCERT) {
        setDataForm(initialStateFromDISendEmail);
        setDataState(initialStateStatusNT);
        setErrorsStatus({});
        setPdfBlob(null);    
        setPdfUrl(""); 
        setChecklistState(false);
        setDialogOpen(false);
        setDialogMessage(null);
        setFoundNumberOfNT(false);
        dispatch(setLoading(false));   
        navigate("/nt");
      }
    },
    [
      setDataForm,  
      setDataState,
      setErrorsStatus,
      setPdfBlob,    
      setPdfUrl,
      setChecklistState,
      setDialogOpen,
      setDialogMessage, 
      setFoundNumberOfNT,
      showModalNTSendESIRCERT,  
      dispatch,
      navigate]
  );
  
  const handleCloseSendESIR = () => {
    setDataForm(initialStateFromDISendEmail);
    setDataState(initialStateStatusNT);
    setErrorsStatus({});
    setPdfBlob(null);    
    setPdfUrl(""); 
    setChecklistState(false);
    setDialogOpen(false);
    setDialogMessage(null);
    setFoundNumberOfNT(false);
    dispatch(setLoading(false));  
    navigate("/nt");
	};  

  const handleBlurDataEditStatus = (e) => {
    handleChangeDataEditStatus(e);
    setErrorsStatus(validateformStatus());
  };

  const handleChangeDataEditStatus = (e) => {
    const { name, value } = e.target;
    setDataState (dataState => ({
      ...dataState,
      [name]: value,
    }));
  };

   const handleBlurSelectDate = (e) => {
    handleChangeSelectDate(e);
    setErrorsStatus(validateformStatus());
  };

  const handleChangeSelectDate = (event) => {
    const selectedDate = event ? new Date(event) : null;
    const endDate = selectedDate ? new Date(selectedDate) : null;
    if (endDate) {
      endDate.setFullYear(endDate.getFullYear() + 3);
    }
    setDataState(dataState => ({
      ...dataState,
      init_date_nt: selectedDate,
      end_date_nt: endDate,
    }));
  }; 

  const handleBlurSelectEndDate = (e) => {
    handleChangeSelectEndDate(e);
    setErrorsStatus(validateformStatus());
  };
 
  const handleChangeSelectEndDate = (event) => {
    setDataState(formNT => ({
      ...formNT,
      end_date_nt: event!==null?new Date(event):null
    }));
  };
  
  const validateformStatus = () => {
    let errorsStatus = {};
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
     
    if (!dataState.number_nt || dataState.number_nt==="") {
      errorsStatus.number_nt = 'Text_Field_NT_Sheet_Required'; 
    } else {
      if (regexInvalidCharacters.test(dataState.number_nt)) {
        errorsStatus.number_nt = 'Text_TextNoValid';
      }
    }    
    if (foundNumberOfNT){
      errorsStatus.number_nt='Text_FieldnumberdiExist';
    }  
    if (!dataState.init_date_nt || dataState.init_date_nt===null || dataState.init_date_nt==="") {
      errorsStatus.init_date_nt = 'Text_DateMustBeAtLeast10DaysLater';
    } 
     if (!dataState.end_date_nt || dataState.end_date_nt===null || dataState.end_date_nt==="") {
      errorsStatus.end_date_nt = 'Text_EndDateMustBeNOTEMPTY';
    } else {
      if ( dataState.end_date_nt< dataState.init_date_nt) {
        errorsStatus.end_date_nt = 'Text_EndDateMustBeGreater';
      }
    }


    return errorsStatus;
  }; 
  const validateFormEmail = () => {
    return dataForm.checked_numberDI_sheet  
        && dataForm.checked_opt_tras_documentid 
        && dataForm.checked_opt_tras_tradename 
        && dataForm.checked_opt_tras_street 
        && dataForm.checked_opt_tras_locality 
        && dataForm.checked_opt_tras_nima 
        && dataForm.checked_opt_tras_opt 
        && dataForm.checked_opt_tras_inscription 
        && dataForm.checked_ori_tras_documentid 
        && dataForm.checked_ori_tras_tradename 
        && dataForm.checked_ori_tras_street 
        && dataForm.checked_ori_tras_locality 
        && dataForm.checked_ori_tras_nima 
        && dataForm.checked_ori_tras_opt 
        && dataForm.checked_ori_tras_inscription 
        && dataForm.checked_dest_tras_documentid 
        && dataForm.checked_dest_tras_tradename 
        && dataForm.checked_dest_tras_street 
        && dataForm.checked_dest_tras_locality 
        && dataForm.checked_dest_tras_nima 
        && dataForm.checked_dest_tras_opt 
        && dataForm.checked_dest_tras_inscription 
        && dataForm.checked_codeLER  
        && dataForm.checked_amount; 
  };

  const toBase64UTF8 = (str) => {
    const bytes = new TextEncoder().encode(str);
    let binary = '';
    bytes.forEach((b) => (binary += String.fromCharCode(b)));
    return btoa(binary);
  };

  const decodeBase64ToUtf8 = (b64) => {
    const bin = atob(b64);
    const bytes = Uint8Array.from(bin, c => c.charCodeAt(0));
    return new TextDecoder('utf-8').decode(bytes);
  };
  
  const extractXmlFromResponseDTOs = (list) => {
    if (!Array.isArray(list)) return null;

    // busca el primer OK con payload
    const item = list.find(e =>
      e && e.response &&
      (e.status === 'OK' || e.status === 200 || e.status === 'HttpStatus.OK' || e.status?.code === 200)
    ) || list.find(e => e && e.response); // fallback: cualquier con response

    if (!item) return null;

    const payload = item.response;

    // caso 1: ya es XML en claro
    if (typeof payload === 'string') {
      const trimmed = payload.trim();
      return trimmed.startsWith('<') ? trimmed : decodeBase64ToUtf8(trimmed); // si no empieza por <, asumimos base64
    }

    // caso 2: Buffer serializado
    if (payload && typeof payload === 'object' && payload.type === 'Buffer' && Array.isArray(payload.data)) {
      const bytes = new Uint8Array(payload.data);
      return new TextDecoder('utf-8').decode(bytes);
    }

    // caso 3: byte[] serializado como array de números
    if (Array.isArray(payload) && payload.every(n => Number.isInteger(n))) {
      const bytes = new Uint8Array(payload);
      return new TextDecoder('utf-8').decode(bytes);
    }

    // caso 4: objeto con campo base64 explícito
    if (payload && typeof payload.base64 === 'string') {
      return decodeBase64ToUtf8(payload.base64);
    }

    return null;
  }; 

  const sendDataToMiteco = (xmlText, dataForm) => {
    let isMounted = true;
    const socket = new WebSocket('ws://localhost:8080');
    const normMunicipioCode = (c) => {
      const onlyDigits = String(c || '').replace(/\D/g, '');
      return onlyDigits.length >= 5 ? onlyDigits.slice(0, 5) : onlyDigits;
    };
    const formDIDTO = {
      ori_tras_documentid: dataForm.opt_tras_documentid || '',
      dir: dataForm.opt_tras_address || '',
      cp: String(dataForm.opt_tras_postalcode_localityCode || ''),
      tel: dataForm.opt_tras_phone || '--',
      movil: dataForm.opt_tras_phone || '--',
      email: dataForm.opt_tras_mail || 'notiene@gmail.com',
      provincia: dataForm.ori_tras_province_provinceName || 'Palmas, Las',
      provincia_code: String(dataForm.ori_tras_province_provinceCode || '35'), 
      municipio: dataForm.ori_tras_municipality_municipalityName || 'Santa Lucía de Tirajana',
      municipio_code: normMunicipioCode(dataForm.ori_tras_municipality_municipalityCode || '35022'),
    };
    socket.addEventListener('open', () => {
      const payload = {
        type: 'send-miteco',
        content: {
          formDIDTO, // el de arriba
          xml: { filename: `nt_${Date.now()}.xml`, base64: toBase64UTF8(xmlText) }
        }
      };
      socket.send(JSON.stringify(payload)); 
    });

    socket.addEventListener('message', (event) => {
      if (!isMounted) return;
        try {
          const resp = JSON.parse(event.data);
          let typeToSend=2;
          let textToSend ="";
          if (resp.status === 'success') {
            // Prioriza mostrar los alerts si vienen
            const text = (resp.alerts && resp.alerts.length)
              ? resp.alerts.join('\n')
              : (resp.message || t('Text_ERROR_MITECO_NOT'));
            dispatch(setLoading(false));
            if (resp.ok){
              typeToSend=3;
              textToSend=t('Text_OK_MITECO_TOO_SIGN');
              setDialogMessage({ status: "OK", errors: [t('Text_OK_MITECO_TOO_SIGN')] });
              setDialogOpen(true);
            }else{ 
              const errorList = (text || t('Text_IncorrectData'));
              typeToSend=2;
              textToSend=errorList; 
              setDialogMessage({ status: "ERROR", errors: [errorList] });
              setDialogOpen(true);
            } 
          } else {
            typeToSend=2;
            textToSend=resp.message || t('Text_ERROR_MITECO'); 
            dispatch(setLoading(false)); 
            dispatch(warningErrorAction(resp.message || t('Text_ERROR_MITECO')));
          }
          handleSubmitNT(typeToSend,textToSend); 
        } catch {
          dispatch(warningErrorAction(t('Text_ERROR_MITECO')));
          dispatch(setLoading(false)); 
        } finally {
          if (socket.readyState === WebSocket.OPEN) socket.close();
          dispatch(setLoading(false));
        }
    });

    socket.addEventListener('error', () => {
       dispatch(setLoading(false));
      if (isMounted) dispatch(warningErrorAction(t('Text_ERROR_MITECO')));
    });

    socket.addEventListener('close', (event) => {
       dispatch(setLoading(false));
      if (!event.wasClean && isMounted) {
        dispatch(warningErrorAction(t('Text_ERROR_MITECO')));
      }
    });

    return () => {
      isMounted = false;
       if (socket.readyState === WebSocket.OPEN) socket.close();
    };

  };  
  
  const handleSubmitSendESIR = async () => {
    const isValid = validateFormEmail();
    if (!isValid) {
      setDialogMessage({ status: "ERROR", errors: [t('Text_IncorrectData')] });
      setDialogOpen(true);
      return;
    }
    dispatch(setLoading(true)); 
    try {
      const getData = await helpHttp().post(ENDPOINT, `api/esir/saventeesir`, token, dataForm);
      const hasSuccess = getData.some(entry => entry.status === "OK");
      if (hasSuccess) {
        const xmlText = extractXmlFromResponseDTOs(getData);
        if (!xmlText || !xmlText.trim().startsWith('<')) {
          setDialogMessage({ status: "ERROR", errors: [t('Text_Unexpected_Error_XML_Sending_To_eSIR')] });
          dispatch(setLoading(false));
        }else{
          sendDataToMiteco(xmlText, dataForm);
        }
      } else {
        setDialogOpen(true);
        const errorList = getData.map(item => item.cause || t('Text_IncorrectData'));
        setDialogMessage({ status: "ERROR", errors: errorList });
        dispatch(setLoading(false));
      } 
    } catch (error) {
      dispatch(setLoading(false));
      setDialogMessage({ status: "ERROR", errors: [t('Text_ConnectionFailed')] });
    } 
  };

  const handleCloselDialogESIR = () => {
    setDialogOpen(false);
    setDialogMessage(null); 
    handleCloseSendESIR(); 
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  const handleConfirmFetchDataSendStatus = (dataToSend) => {  
    const fetchData = async () => { 
      try {
        const getData = await helpHttp().put(ENDPOINT, `nt/updatenttoesir`, token, dataToSend);
        if (getData.status === "OK") {
          dispatch(successErrorAction(t('Text_SaveData')));
          setChecklistState(dataForm.checked_numberDI_sheet 
            && dataForm.checked_opt_tras_documentid 
            && dataForm.checked_opt_tras_tradename 
            && dataForm.checked_opt_tras_street 
            && dataForm.checked_opt_tras_locality 
            && dataForm.checked_opt_tras_nima 
            && dataForm.checked_opt_tras_opt 
            && dataForm.checked_opt_tras_inscription 
            && dataForm.checked_ori_tras_documentid 
            && dataForm.checked_ori_tras_tradename 
            && dataForm.checked_ori_tras_street 
            && dataForm.checked_ori_tras_locality 
            && dataForm.checked_ori_tras_nima 
            && dataForm.checked_ori_tras_opt 
            && dataForm.checked_ori_tras_inscription 
            && dataForm.checked_dest_tras_documentid 
            && dataForm.checked_dest_tras_tradename 
            && dataForm.checked_dest_tras_street 
            && dataForm.checked_dest_tras_locality 
            && dataForm.checked_dest_tras_nima 
            && dataForm.checked_dest_tras_opt 
            && dataForm.checked_dest_tras_inscription  
            && dataForm.checked_codeLER  
            && dataForm.checked_amount  
          )
          if(Number(dataToSend.statussentesir)===0 || Number(dataToSend.statussentesir)===4 ){
            setDataForm(dataForm => ({
              ...dataForm,  
              reasonrefund:""            
            })); 
            setDataState(dataState => ({
              ...dataState, 
              reasonrefund:""            
            }));
          }
        } else {
          dispatch(warningErrorAction(t(getData.cause)));
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
    fetchData();
    return () => {};
  };

  const handleSubmitNT = (typeToSend,errorToSend) => {  
    const fetchData = async (formToSend) => { 
      try {
        const getData = await helpHttp().put(ENDPOINT, `nt/updatenttoesir`, token, formToSend);
        if (getData.status === "OK") {
          dispatch(successErrorAction(t('Text_SaveData'))); 
          setChecklistState(dataForm.checked_numberDI_sheet 
            && dataForm.checked_opt_tras_documentid 
            && dataForm.checked_opt_tras_tradename 
            && dataForm.checked_opt_tras_street 
            && dataForm.checked_opt_tras_locality 
            && dataForm.checked_opt_tras_nima 
            && dataForm.checked_opt_tras_opt 
            && dataForm.checked_opt_tras_inscription 
            && dataForm.checked_ori_tras_documentid 
            && dataForm.checked_ori_tras_tradename 
            && dataForm.checked_ori_tras_street 
            && dataForm.checked_ori_tras_locality 
            && dataForm.checked_ori_tras_nima 
            && dataForm.checked_ori_tras_opt 
            && dataForm.checked_ori_tras_inscription 
            && dataForm.checked_dest_tras_documentid 
            && dataForm.checked_dest_tras_tradename 
            && dataForm.checked_dest_tras_street 
            && dataForm.checked_dest_tras_locality 
            && dataForm.checked_dest_tras_nima 
            && dataForm.checked_dest_tras_opt 
            && dataForm.checked_dest_tras_inscription  
            && dataForm.checked_codeLER  
            && dataForm.checked_amount  
          ) 
        } else {
          dispatch(warningErrorAction(t(getData.cause)));
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
    const formToSend = {
      ...dataState,  
      statussentesir:typeToSend,
      reasonrefund:errorToSend
    };
    fetchData(formToSend);
    return () => {};
  }; 
 
  const handleSubmitDataEditNT = () => {
    const errors = validateformStatus();
    setErrorsStatus(errors);
    if (Object.keys(errors).length === 0 && dataForm.preiddoc_sheet !== '') {
      setDataForm(dataForm => ({
        ...dataForm, 
        number_dt: dataState.number_nt,
        date_sheet:dataState.init_date_nt,
        end_date_nt:dataState.end_date_nt,
        statussentesir:dataState.statussentesir,
        reasonrefund:dataState.reasonrefund
      }));
      const formToSend = {
        ...dataState
      };
      handleConfirmFetchDataSendStatus(formToSend); 
    } else {
      if (errorsStatus.number_nt) {
        dispatch(warningErrorAction(t(errorsStatus.number_nt)));
      } else if (errorsStatus.init_date_nt) {
        dispatch(warningErrorAction(t(errorsStatus.init_date_nt)));
      } else if (errors.end_date_nt) {
        dispatch(warningErrorAction(t(errorsStatus.end_date_nt)));
      } else if (errors.reasonrefund) {
        dispatch(warningErrorAction(t(errorsStatus.reasonrefund)));
      } else {
          dispatch(warningErrorAction(t('Text_IncorrectData')));
      }
    }
  }; 

  useEffect(() => {
      let isMounted = true;
      const fetchExistNumberNT = async () => {
          try {
            const getData = await helpHttp().get11(ENDPOINT,`nt/getExistNumberntbynt`,token,dataState.number_nt.replace(/[.\-/\\|]/g, "")) ;
            if (getData.err) {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            } else if (isMounted) {
              setFoundNumberOfNT(getData!==dataState.id && getData>0)       
            }
          } catch (error) {
              dispatch(warningErrorAction(t('Text_IncorrectData'))); 
          }
      }; 
      if (dataState.number_nt && dataState.number_nt.replace(/[.\-/\\|]/g, "").trim()!==""){
        fetchExistNumberNT();
      } 
      return () => { isMounted = false };
    }, [t,token,dispatch,dataState.number_nt,dataState.id]);
    
    
  useEffect(() => {
    let isMounted = true;
    const fetchFileForm = async (fileName) => {
       try {
        const getData = await helpHttp().getfilesupload(ENDPOINT, `pdftos3uploader/downloadfroms3`, token,fileName);
        if (!getData) { 
          setPdfUrl("");
          dispatch(warningErrorAction(t('Text_ConnectionFailed'))); 
        } else{ 
          if (getData && getData.size>0){
            const url = URL.createObjectURL(getData);
            setPdfUrl(url); // Guardar la URL del PDF para mostrarlo en <iframe>  
          } 
        }
      } catch (error) {
        setPdfUrl("");
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  

    const fetchDataNT = async () => {
      dispatch(setLoading(true));
      try {
         const getData = await helpHttp().get2(ENDPOINT, `api/esir/getpdfntbyid/`, token, id); 
        if (getData.err) {
          setDataForm(initialStateFromDISendEmail); 
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setDataForm(getData);
          setDataState(dataState => ({
            ...dataState,
            id:getData.id,
            number_nt: getData.number_dt,
            init_date_nt:getData.date_sheet,
            end_date_nt:getData.end_date_nt,
            statussentesir:getData.statussentesir,
            reasonrefund:getData.reasonrefund
          }));
          if (getData.isScanned){
            setPdfBlob(null)
            let fileName = "NT_"+getData.number_dt+ ".pdf"; 
            fetchFileForm(fileName); 
          }  
          setChecklistState(getData.checked_numberDI_sheet 
            && getData.checked_opt_tras_documentid 
            && getData.checked_opt_tras_tradename 
            && getData.checked_opt_tras_street 
            && getData.checked_opt_tras_locality 
            && getData.checked_opt_tras_nima 
            && getData.checked_opt_tras_opt 
            && getData.checked_opt_tras_inscription 
            && getData.checked_ori_tras_documentid 
            && getData.checked_ori_tras_tradename 
            && getData.checked_ori_tras_street 
            && getData.checked_ori_tras_locality 
            && getData.checked_ori_tras_nima 
            && getData.checked_ori_tras_opt 
            && getData.checked_ori_tras_inscription 
            && getData.checked_dest_tras_documentid 
            && getData.checked_dest_tras_tradename 
            && getData.checked_dest_tras_street 
            && getData.checked_dest_tras_locality 
            && getData.checked_dest_tras_nima 
            && getData.checked_dest_tras_opt 
            && getData.checked_dest_tras_inscription  
            && getData.checked_codeLER  
            && getData.checked_amount  
          )
          dispatch(setLoading(false));
        }  
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
    if (id!=="0"){
      if (!dataForm.id || dataForm.id==="" || dataForm.id===0){
        fetchDataNT(); 
        
        dispatch(setLoading(false));
      }
    }else{
      setDataForm(initialStateFromDISendEmail); 
      setDataState(initialStateStatusNT);
      dispatch(setLoading(false));
    }
    return () => { isMounted = false };
  }, [dispatch,id,t,token,pdfBlob,dataForm.id,defaultStore.id,useraccount_id,
    dataForm.date_sheet,dataForm.end_date_nt,dataForm.number_dt,dataForm.preiddoc_sheet,
    dataForm.reasonrefund,dataForm.statussentesir,dataForm.sufiddoc_sheet]);   
  return (
    <>
     {showModalNTSendESIRCERT ? ( 
        <div className="container-fluid email-send-wrapper">
          <Box sx={{ bgcolor: '#ffffff', width: '1050px' }}>

            {/* HEADER */}
            <div className="formgeneral-card-header">
              <div className="formgeneral-header-content">
                <div className="formgeneral-header-title2">
                  {isLoadingData ? (
                    <CircularProgress sx={{ color: "#f6c23e" }} />
                    ) : (
                      <>
                        <img
                          src={sedeElectronicaIcon}
                          alt="sedeElectronicaIcon"
                          style={{
                            width: "80px",
                            height: "50px",
                            verticalAlign: "middle",
                            backgroundColor: "white",
                            borderRadius: "4px",
                            padding: "2px"
                          }}
                        />
                        &nbsp;&nbsp;{dataForm.number_dt.trim()}
                      </>
                    )}
                </div>
                <div className="email-card-actions">
                  {isLoadingData?
                    <CircularProgress sx={{ color : "#f6c23e"}}/>:
                    <>
                      <button type="button" className="formgeneral-cancel-btn" onClick={handleCloseSendESIR} >
                        {t('Button_Back').toLocaleUpperCase()}
                      </button> 
                    </>
                  } 
                </div>
              </div>
            </div>
            <br/>
            {/* FORM CARD */}
            <form className="createform" onSubmit={handleCloseSendESIR}>  
              {!isLoadingData ?
                <>   
                  {/* HEADER */}
                  <div className="formgeneral-card-header">
                    <div className="formgeneral-header-content">
                      <div className="formgeneral-header-title2">
                        {dataState.number_nt}
                      </div>
                      <div className="email-card-actions">
                        <button type="button" className="formgeneral-send-btn" onClick={handleSubmitDataEditNT} >
                          {t('Button_Modified_Status')}
                        </button>  
                      </div>
                    </div>

                    <div className="email-card-form">
                      <div className="row p-4">
                        <div className="form-group">   
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_New_NT')} :</label>
                          &nbsp;&nbsp;&nbsp;&nbsp; 
                          <TextField
                            id="number_nt" 
                            name="number_nt"
                            value={dataState.number_nt}
                            inputProps={{ style: {width: i18n.language==='es'?400:400,  fontSize: '18px'}, maxLength: 30 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                            label={errorsStatus.number_nt!=null?t(errorsStatus.number_nt):t('Placeholder_New_NT')}
                            placeholder={t('Placeholder_New_NT')}
                            variant="standard"
                            onBlur={handleBlurDataEditStatus}
                            onChange={handleChangeDataEditStatus}
                          /> 
                        </div>
                        <div className="form-group">   
                          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                            <label className={errorsStatus.init_date_nt ? "text-danger" : "text-primary"} style={{ fontSize: 18 }}>{t('Text_NT_INIT_DATE')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <DesktopDatePicker
                              id="init_date_nt"
                              name="init_date_nt"
                              value={dataState.init_date_nt !== null ? new Date(dataState.init_date_nt) : null}
                              format={i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy"}
                              label={errorsStatus.init_date_nt!=null?t(errorsStatus.init_date_nt):t('Text_NT_INIT_DATE')}
                              onBlur={handleBlurSelectDate}
                              onChange={handleChangeSelectDate}
                              slotProps={{
                                textField: {
                                  placeholder: i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy",
                                  error: !!errorsStatus.init_date_nt, //
                                  helperText: errorsStatus.init_date_nt ? t(errorsStatus.init_date_nt) : "",
                                  sx: {
                                    width: i18n.language === 'es' ? 159 : 168,
                                    fontSize: '18px',
                                  },
                                  InputProps: {
                                    style: {
                                      fontSize: '18px',
                                    },
                                  },
                                  InputLabelProps: {
                                    style: {
                                      fontSize: '18px',
                                      background: '#FFFFFF',
                                    },
                                  },
                                },
                              }}
                            />
                          </LocalizationProvider> 
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_NT_END_DATE')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <DesktopDatePicker
                              id="end_date_nt" 
                              name="end_date_nt"
                              minDate={dataState.init_date_nt!== null ? new Date(dataState.init_date_nt): null}
                              value={ dataState.end_date_nt!== null ? new Date(dataState.end_date_nt):null}
                              format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                              label={errorsStatus.end_date_nt!=null?t(errorsStatus.end_date_nt):t('Text_NT_END_DATE')}
                              onBlur={handleBlurSelectEndDate}
                              onChange={handleChangeSelectEndDate}
                              slotProps={{
                                textField: {
                                  placeholder: i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy",
                                  error: !!errorsStatus.end_date_nt, //
                                  helperText: errorsStatus.end_date_nt ? t(errorsStatus.end_date_nt) : "",
                                  sx: {
                                    width: i18n.language === 'es' ? 159 : 168,
                                    fontSize: '18px',
                                  },
                                  InputProps: {
                                    style: {
                                      fontSize: '18px',
                                    },
                                  },
                                  InputLabelProps: {
                                    style: {
                                      fontSize: '18px',
                                      background: '#FFFFFF',
                                    },
                                  },
                                },
                              }}
                              
                            />
                          </LocalizationProvider> 
                        </div>
                        <div className="form-group">
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_STATUS')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <TextField
                              id="statussentesir"
                              name="statussentesir"
                              value={ (dataState.statussentesir === undefined || dataState.statussentesir ===null || dataState.statussentesir ==="")?"EN TRÁMITE":dataState.statussentesir}
                              inputProps={{ style: {width: 200,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              variant="standard"
                              onBlur={handleBlurDataEditStatus}
                              onChange={handleChangeDataEditStatus}
                              helperText={errorsStatus.statussentesir!=null?t(errorsStatus.statussentesir):""}
                              select
                              SelectProps={{
                                  native: true,
                                  value: (dataState.statussentesir === undefined || dataState.statussentesir ===null || dataState.statussentesir ==="")?"EN TRÁMITE": dataState.statussentesir
                              }}>
                              {typeStatus.map((option) => (
                                  <option key={option.id} value={option.id}>
                                      {option.name}
                                  </option>
                              ))}
                            </TextField>  
                          </div>
                          <div className="form-group">
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_STATUS_REFUND_REASO')} :</label>
                              &nbsp;&nbsp;&nbsp;&nbsp;   
                              <Textarea 
                                id="reasonrefund" 
                                name="reasonrefund"
                                value={dataState.reasonrefund}
                                label={errorsStatus.reasonrefund!=null?t(errorsStatus.reasonrefund):t('Placeholder_STATUS_REFUND_REASO')}
                                placeholder={t('Placeholder_STATUS_REFUND_REASO')}
                                sx={{width: 950, fontSize: 18} }
                                variant="standard"
                                onBlur={handleBlurDataEditStatus}
                                onChange={handleChangeDataEditStatus}
                                maxRows={8}
                            />  
                          </div>
                      </div>
                    </div>
                  </div>
                  <br/>
                  {/* HEADER */}
                  <div className="formgeneral-card-header">
                    <div className="formgeneral-header-content">
                      <div className="formgeneral-header-title2">
                        {t("Text_Requirements_TITTLE_NT_MITECO")}
                      </div>
                      <div className="email-card-actions">
                        <button
                          type="button"
                          className={!checklistState?"esir-nosend-btn":"esir-send-btn"}
                          onClick={handleSubmitSendESIR}
                          disabled={!checklistState}
                        >
                          <img
                            src={mitecoIcon}
                            alt="mitecoIcon"
                            style={{
                              width: 70,
                              height: 30,
                              backgroundColor:!checklistState?"rgb(234, 233, 233)":"white", // fondo blanco en el icono
                              verticalAlign: "middle",
                              borderRadius: "6px",
                              padding: "2px"
                            }}
                          />
                          &nbsp;
                          <SendIcon sx={{ fontSize: 28, color: !checklistState?"rgba(95, 94, 92, 0.5)":"#df974e" }} />
                        </button>  
                      </div>
                    </div>
                    <div className="email-card-form">
                      <div className="row p-4">
                        <h6 className="mb-3 text fw-bold" style={{ color:"#df974e",fontSize: 18 }}>{t("Text_FORM_Requirements_OPT_TRAS")}</h6>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group">   
                              <Checkbox checked={dataForm.checked_numberDI_sheet} 
                                sx={{
                                  '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 18 }, // Ajusta el tamaño del ícono
                                  }}
                                disabled />
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Requirements_NUM_NT').toUpperCase()}</label>
                              <br/>
                              <h6 className="mb-3 text fw-bold" style={{ color:"#df974e",fontSize: 18 }}>{t("Text_FORM_Requirements_OPT_TRAS")}</h6>
                              <hr className="sidebar-divider d-none d-md-block"/>


                              <Checkbox checked={dataForm.checked_opt_tras_documentid} 
                                sx={{
                                  '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 18 }, // Ajusta el tamaño del ícono
                                  }}
                                disabled 
                              />
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Requirements_CIF').toUpperCase()}</label>
                              <br/>
                              <Checkbox checked={dataForm.checked_opt_tras_tradename} 
                                sx={{
                                  '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 18 }, // Ajusta el tamaño del ícono
                                  }}
                                disabled 
                              />
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Requirements_TRADENAME').toUpperCase()}</label>
                              <br/>
                              <Checkbox checked={dataForm.checked_opt_tras_street} 
                                sx={{
                                  '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 18 }, // Ajusta el tamaño del ícono
                                  }}
                                disabled 
                              />
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Requirements_Address').toUpperCase()}</label>
                              <br/>
                              <Checkbox checked={dataForm.checked_opt_tras_locality} 
                                sx={{
                                  '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 18 }, // Ajusta el tamaño del ícono
                                  }}
                                disabled />
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Requirements_PostalCode').toUpperCase()}</label>
                              <br/>
                              <Checkbox checked={dataForm.checked_opt_tras_nima} 
                                sx={{
                                  '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 18 }, // Ajusta el tamaño del ícono
                                  }}
                                disabled 
                              />
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Requirements_NIMA').toUpperCase()}</label>
                              <br/>
                              <Checkbox checked={dataForm.checked_opt_tras_opt} 
                                sx={{
                                  '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 18 }, // Ajusta el tamaño del ícono
                                  }}
                                disabled 
                              />
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Requirements_OPT').toUpperCase()}</label>
                              <br/>
                              <Checkbox checked={dataForm.checked_opt_tras_inscription} 
                                sx={{
                                  '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 18 }, // Ajusta el tamaño del ícono
                                  }}
                                disabled />
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Requirements_INSCRIPTION').toUpperCase()}</label>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">   
                              <Checkbox checked={dataForm.checked_date_sheet} 
                                sx={{
                                  '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 18 }, // Ajusta el tamaño del ícono
                                  }}
                                disabled />
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Date').toUpperCase()}</label>
                              <br/> 
                              <h6 className="mb-3 text fw-bold" style={{ color:"#df974e",fontSize: 18 }}>{t("Text_FORM_Requirements_ORI_TRAS")}</h6>
                              <hr className="sidebar-divider d-none d-md-block"/>
                              <Checkbox checked={dataForm.checked_ori_tras_documentid} 
                                sx={{
                                  '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 18 }, // Ajusta el tamaño del ícono
                                  }}
                                disabled 
                              />
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Requirements_CIF').toUpperCase()}</label>
                              <br/>
                              <Checkbox checked={dataForm.checked_ori_tras_tradename} 
                                sx={{
                                  '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 18 }, // Ajusta el tamaño del ícono
                                  }}
                                disabled 
                              />
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Requirements_TRADENAME').toUpperCase()}</label>
                              <br/>
                              <Checkbox checked={dataForm.checked_ori_tras_street} 
                                sx={{
                                  '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 18 }, // Ajusta el tamaño del ícono
                                  }}
                                disabled 
                              />
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Requirements_Address').toUpperCase()}</label>
                              <br/>
                              <Checkbox checked={dataForm.checked_ori_tras_locality} 
                                sx={{
                                  '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 18 }, // Ajusta el tamaño del ícono
                                  }}
                                disabled />
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Requirements_PostalCode').toUpperCase()}</label>
                              <br/>
                              <Checkbox checked={dataForm.checked_ori_tras_nima} 
                                sx={{
                                  '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 18 }, // Ajusta el tamaño del ícono
                                  }}
                                disabled 
                              />
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Requirements_NIMA').toUpperCase()}</label>
                              <br/>
                              <Checkbox checked={dataForm.checked_ori_tras_opt} 
                                sx={{
                                  '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 18 }, // Ajusta el tamaño del ícono
                                  }}
                                disabled 
                              />
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Requirements_OPT').toUpperCase()}</label>
                              <br/>
                              <Checkbox checked={dataForm.checked_ori_tras_inscription} 
                                sx={{
                                  '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 18 }, // Ajusta el tamaño del ícono
                                  }}
                                disabled />
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Requirements_INSCRIPTION').toUpperCase()}</label>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group"> 
                              <Checkbox checked={dataForm.checked_codeLER} 
                                sx={{
                                  '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 18 }, // Ajusta el tamaño del ícono
                                  }}
                                disabled />
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CodeLER_Code').toUpperCase()}</label>
                              <br/> 
                              <h6 className="mb-3 text fw-bold" style={{ color:"#df974e",fontSize: 18 }}>{t("Text_FORM_Requirements_DEST_TRAS")}</h6>  
                              <hr className="sidebar-divider d-none d-md-block"/>
                              <Checkbox checked={dataForm.checked_dest_tras_documentid} 
                                sx={{
                                  '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 18 }, // Ajusta el tamaño del ícono
                                  }}
                                disabled 
                              />
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Requirements_CIF').toUpperCase()}</label>
                              <br/>
                              <Checkbox checked={dataForm.checked_dest_tras_tradename} 
                                sx={{
                                  '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 18 }, // Ajusta el tamaño del ícono
                                  }}
                                disabled 
                              />
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Requirements_TRADENAME').toUpperCase()}</label>
                              <br/>
                              <Checkbox checked={dataForm.checked_dest_tras_street} 
                                sx={{
                                  '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 18 }, // Ajusta el tamaño del ícono
                                  }}
                                disabled 
                              />
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Requirements_Address').toUpperCase()}</label>
                              <br/>
                              <Checkbox checked={dataForm.checked_dest_tras_locality} 
                                sx={{
                                  '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 18 }, // Ajusta el tamaño del ícono
                                  }}
                                disabled />
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Requirements_PostalCode').toUpperCase()}</label>
                              <br/>
                              <Checkbox checked={dataForm.checked_dest_tras_nima} 
                                sx={{
                                  '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 18 }, // Ajusta el tamaño del ícono
                                  }}
                                disabled 
                              />
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Requirements_NIMA').toUpperCase()}</label>
                              <br/>
                              <Checkbox checked={dataForm.checked_dest_tras_opt} 
                                sx={{
                                  '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 18 }, // Ajusta el tamaño del ícono
                                  }}
                                disabled 
                              />
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Requirements_OPT').toUpperCase()}</label>
                              <br/>
                              <Checkbox checked={dataForm.checked_dest_tras_inscription} 
                                sx={{
                                  '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 18 }, // Ajusta el tamaño del ícono
                                  }}
                                disabled />
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Requirements_INSCRIPTION').toUpperCase()}</label> 
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> 
                  {/* PDF CARD */}
                  <div className="email-card-pdf">
                    {PdfViewer}
                  </div> 
                </>:
                  <LoadingNews/>
              }
            </form>
            </Box> 
            {!pdfUrl  && 
              <ReportTemplateNTCERT dataForm={dataForm}  setPdfBlob={setPdfBlob}/> 
            }
            <Dialog
              open={dialogOpen && !isLoadingData}
              onClose={handleCloselDialogESIR}
              maxWidth="md"
              fullWidth
              classes={{
                paper: dialogMessage?.status === "OK"  ? "esir-dialog-paper success" : "esir-dialog-paper error"
              }}
              slots={{ backdrop: Backdrop }}
              slotProps={{ backdrop: { className: "esir-dialog-backdrop" } }}
            >
              <DialogTitle
                className={`esir-dialog-title ${
                  dialogMessage?.status === "OK"  ? "esir-dialog-title--ok" : "esir-dialog-title--error"
                }`}
              >
                {dialogMessage?.status === "OK"  ? t("Text_Successful_Send") : t("TextResulut_Send")}
                <small>{dataForm.preiddoc_sheet}{dataForm.sufiddoc_sheet}</small>
              </DialogTitle> 
              <div className="esir-dialog-titlebar" /> 
              <DialogContent dividers className="esir-dialog-content">
                <div className="esir-dialog-content-inner">
                  <ul className="esir-dialog-list">
                    {dialogMessage?.errors?.map((err, idx) => (
                      <li
                        key={idx}
                        className={`esir-dialog-item ${dialogMessage?.status === "OK" ? "ok" : "error"}`}
                      >
                        {t(err)}
                      </li>
                    ))}
                  </ul>
                </div>
              </DialogContent>

              {!isLoadingData && (
                <DialogActions className="esir-dialog-actions">
                  <Button
                    variant="contained"
                    disableElevation
                    onClick={handleCloselDialogESIR}
                    className={`esir-dialog-btn-close ${dialogMessage?.status === "OK"  ? 'success' : ''}`}
                  >
                    {t('Button_Exit')}
                  </Button>
                </DialogActions>

              )}
            </Dialog> 
          </div>  

       //* End Page Content *//
     ) :  null }
   </> 
  )    
}

NTSendESIRCERT.propTypes = {
  id: PropTypes.string.isRequired,
  showModalNTSendESIRCERT: PropTypes.bool.isRequired
};

export default NTSendESIRCERT;